<div
  class="fixed top-[76px] bottom-[10px] left-2 z-10 flex flex-col"
  [style.width.px]="mapContainerService.leftComponentConfig().currentWidth()"
>
  <div class="!w-full flex flex-col h-full bg-primary-accumin-white">
    <div id="fixedContainer" class="sticky top-0 bg-transparent z-20" [class.shadow-2xl]="isScrollable">
      <app-layer-header (closeModule)="closeLayers()" (minimizeModule)="minimizeLayers()" />
    </div>

    @if (isLoading()) {
      <div class="flex flex-col gap-2">
        @for (_ of [1, 2, 3, 4, 5]; track $index) {
          <app-expansion-panel-skeleton>
            <app-list-skeleton [numberOfRows]="5" />
          </app-expansion-panel-skeleton>
        }
      </div>
    }

    @if (!isLoading() && hasError()) {
      <div class="text-red-500 m-6 text-center">
        {{ "General.UnexpectedError" | transloco }}
      </div>
    }

    @if (layerService.isDeactivated()) {
      <div class="flex align-middle items-center justify-center mt-2 w-full">
        {{ "Module.Layer.DeactivatedInfo" | transloco }}
      </div>
    }

    @if (!layerService.isDeactivated() && !isLoading() && !hasError() && layerGroupViewModels().length === 0) {
      <div class="flex align-middle items-center justify-center mt-2 w-full">
        {{ "Exception.Info.NoData" | transloco }}
      </div>
    }

    @if (!layerService.isDeactivated() && !isLoading() && !hasError() && layerGroupViewModels().length > 0) {
      <div id="scrollableContainer" class="overflow-y-auto flex-grow h-0" (scroll)="onScroll($event)" #scrollableContainer>
        <div class="mb-1 w-full" [formGroup]="layerForm">
          @if (layerService.layerOverviewResponse().status === 1) {
            <div>
              <div formArrayName="layerGroups">
                @for (
                  layerGroupControl of layerGroupsFormArray.controls;
                  track trackByLayerGroup(groupIndex, layerGroupControl);
                  let groupIndex = $index
                ) {
                  <div [formGroupName]="groupIndex">
                    <app-layer-group [groupForm]="layerGroupControl" [viewModel]="layerGroupViewModels()[groupIndex]" />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
